import React, { Component } from 'react';
import HeaderTwo from './components/mondiya/HeaderTwo';
import ServiceBox from './components/mondiya/ServiceBox';
import AboutUsTwo from './components/mondiya/AboutUsTwo';
import HomeBlog from './components/mondiya/HomeBlog';
import ImageGallery from './components/mondiya/ImageGallery';
import FooterTwo from './components/mondiya/FooterTwo';
import HeroSlider from "./components/mondiya/HeroSlider";
import HowItWorks from "./components/mondiya/HowItWorks";
import ServiceBoxTwo from "./components/mondiya/ServiceBoxTwo";

export default class HomeTwo extends Component {
    render() {
        return (
            <div className="main-wrapper">

                {/* Header 2  -- >> */}
                <HeaderTwo />

                {/* Hero Image -->> */}
                <HeroSlider />

                {/* About Us 2 -->> */}
                <AboutUsTwo />

                {/* Blog Area -->> Popular Products */}
                <HomeBlog />

                {/* Service Box --> Our Services */}
                <ServiceBox />

                {/* Course Slider --> How It Works!! */}
                <HowItWorks />

                {/* Course Slider --> Why Choose Us!! */}
                <ServiceBoxTwo />

                {/* Image Gallery Area --> Instagram Image Gallery */}
                <ImageGallery />

                {/* Footer 2 --> Mondiya footer */}
                <FooterTwo />

            </div>
        )
    }
}